import React from "react"
import { Button, Spinner } from "reactstrap"
import PropTypes from "prop-types"

function LoadingButton(props) {
  const { isLoading, children, ...otherProps } = props
  return (
    <Button disabled={isLoading} {...otherProps}>
      {isLoading ? (
        <Spinner color="light" size="sm" className="me-2">
          Loading...
        </Spinner>
      ) : null}
      {children}
    </Button>
  )
}
LoadingButton.propTypes = {
  isLoading: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
  block: PropTypes.bool,
  children: PropTypes.node,
}
export default LoadingButton
